var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 44,
    viewBox: "0 0 104 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_197_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.084 1.8946C101.497 1.30848 100.679 1 99.8452 1H85.5807C84.1142 1 82.8328 2.04884 82.555 3.49871L81.4126 9.3599C81.3354 9.79177 81.6596 10.1928 82.1073 10.1928H84.1913C84.5927 10.1928 84.9324 9.91517 85.0095 9.51414L85.9821 4.54756H99.382L92.5431 39.437H79.1432L80.0849 34.6247C80.1621 34.1928 79.8379 33.7918 79.3902 33.7918H77.3061C76.9048 33.7918 76.5651 34.0694 76.4879 34.4704L75.5462 39.3136C75.3456 40.3316 75.6697 41.365 76.4108 42.1054C76.9974 42.6915 77.8156 43 78.6492 43H92.9136C94.3802 43 95.6616 41.9512 95.9394 40.5013L102.948 4.68638C103.149 3.66838 102.84 2.61954 102.084 1.8946Z",
    fill: "#2261F6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_197_302)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.802 13.2791C13.342 13.2791 13.6505 13.6804 13.4191 14.8226C13.2031 15.9648 12.7558 16.3661 12.2004 16.3661H8.76024L6.13769 29.9182C6.01428 30.5202 5.47435 30.9678 4.13222 30.9678C2.7901 30.9678 2.389 30.4893 2.51242 29.9028L5.13496 16.3507H1.6948C1.15487 16.3507 0.846333 15.9494 1.07773 14.8072C1.30913 13.665 1.74108 13.2637 2.29644 13.2637H12.802V13.2791Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1534 20.1631C23.6934 20.1631 24.0019 20.5644 23.7705 21.7066C23.5545 22.8488 23.1071 23.2501 22.5518 23.2501H17.5227L16.6742 27.6646H22.4592C22.9992 27.6646 23.2768 28.0659 23.0763 29.2081C22.8603 30.3503 22.4129 30.7516 21.8576 30.7516H13.4037C12.7095 30.7516 12.5399 30.3503 12.6633 29.6403L15.6406 14.4058C15.764 13.6803 16.088 13.2944 16.7822 13.2944H25.1126C25.6526 13.2944 25.9611 13.6957 25.7297 14.838C25.5137 15.9802 25.0663 16.3815 24.511 16.3815H18.8648L18.1243 20.2094H23.1534V20.1631Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1879 25.1797C29.864 26.893 30.6044 27.9581 32.1008 27.9581C33.5818 27.9581 34.7851 26.9085 35.1245 25.226V25.1489C35.2479 24.5469 35.7878 24.0993 37.1299 24.0993C38.4721 24.0993 38.8732 24.5469 38.7343 25.1489L38.688 25.3958C38.0247 28.8996 34.8622 31.0297 31.4992 31.0297C28.1516 31.0297 25.8376 28.8533 26.5472 25.3186L27.8431 18.6661C28.5373 15.1469 31.6843 12.9551 35.0319 12.9551C38.4104 12.9551 40.7089 15.0851 40.0456 18.5889L39.9993 18.8359C39.8759 19.4378 39.3051 19.8855 37.963 19.8855C36.6209 19.8855 36.2506 19.4378 36.374 18.8359V18.7587C36.698 17.0763 35.9267 16.0267 34.4457 16.0267C32.9647 16.0267 31.7614 17.0917 31.4375 18.805L30.1879 25.1797Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7909 13.2793C54.3308 13.2793 54.6394 13.6806 54.408 14.8228C54.192 15.965 53.7446 16.3663 53.1892 16.3663H49.7491L47.1265 29.9184C47.0031 30.5204 46.4632 30.968 45.1211 30.968C43.7789 30.968 43.3779 30.5204 43.5167 29.9184L46.1392 16.3663H42.6991C42.1591 16.3663 41.8506 15.965 42.082 14.8228C42.298 13.6806 42.7454 13.2793 43.3007 13.2793H53.7909Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1103 25.1487C57.7863 26.862 58.5576 27.9579 60.0386 27.9579C61.5196 27.9579 62.7383 26.862 63.0622 25.1487L65.222 14.1126C65.3145 13.5106 65.8853 13.063 67.2274 13.063C68.5696 13.063 68.9398 13.5106 68.8318 14.1126L66.6567 25.3339C65.9625 28.8532 62.8154 31.045 59.437 31.045C56.0585 31.045 53.7599 28.8686 54.4541 25.3339L56.6447 14.1126C56.7373 13.5106 57.3081 13.063 58.6502 13.063C59.9923 13.063 60.3626 13.5106 60.2546 14.1126L58.1103 25.1487Z",
    fill: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.3937 29.9028L79.5997 18.5425C79.9237 16.9372 79.3066 16.0574 78.0416 16.0574C76.7766 16.0574 75.8047 16.9218 75.4808 18.5425L73.2747 29.9028C73.1513 30.5047 72.6114 30.9524 71.2693 30.9524C69.9271 30.9524 69.5261 30.5047 69.6649 29.9028L71.8709 18.6197C72.5188 15.2239 75.2185 12.9858 78.4427 12.9858C80.1859 12.9858 81.5126 13.7576 82.1451 14.8535C83.2095 13.7576 84.8448 12.9858 86.588 12.9858C89.8122 12.9858 91.6171 15.2239 90.9846 18.6197L88.7786 29.9028C88.6552 30.5047 88.1152 30.9524 86.7731 30.9524C85.431 30.9524 85.0299 30.5047 85.1687 29.9028L87.3748 18.5425C87.6987 16.9372 87.0816 16.0574 85.8167 16.0574C84.5517 16.0574 83.5798 16.9218 83.2558 18.5425L81.0498 29.9028C80.9264 30.5047 80.3865 30.9524 79.0443 30.9524C77.6714 30.9369 77.2703 30.4893 77.3937 29.9028Z",
    fill: "#F7F8FA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_197_302",
    x: 75.0879,
    y: 0.6,
    width: 28.32,
    height: 42.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0235294 0 0 0 0 0.027451 0 0 0 0 0.0392157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_302"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.2,
    dy: -0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.996078 0 0 0 0 0.937255 0 0 0 0 0.635294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "screen",
    in2: "effect1_dropShadow_197_302",
    result: "effect2_dropShadow_197_302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_197_302",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_197_302",
    x: 0.8,
    y: 12.7551,
    width: 91.31,
    height: 19.2898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.4,
    dy: 0.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.239216 0 0 0 0 0.278431 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_302"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_197_302",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.2,
    dy: 0.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.45098 0 0 0 0 0.517647 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_197_302"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.23f7b3d5a8ff1e6f018ced2f9bb006b0.svg";
export { ForwardRef as ReactComponent };